import React, { useEffect, useMemo } from "react";
import { hot } from "react-hot-loader";
import { compose } from "recompose";
import { Button, Icon, List, Popup } from "semantic-ui-react";
import { withAxios } from "op/components/auth/auth.helper";

function PopUpInfo({axios}) {
    const [data, setData] = React.useState(null);

    useEffect(() => {
        axios.get('/api/Stp/getStpInfo').then(setData);
    }, []);

    const content = useMemo(() => {
        if (!data) return null;

        const items = data.data.split('\n');

        return (
            <List style={{width: '400px'}}>
                {items.map((item, index) => (
                    <List.Item key={index}>{item}</List.Item>
                ))}
            </List>
        );
    }, [data]);

    return (
        <Popup
            on='click'
            content={content || 'Loading...'}
            trigger={
                <Button
                size='mini'
                color="gray"
                style={{marginLeft: '1em', border: '1px solid #555555', width: 'fit-content'}}
                >
                    <Icon name='info circle' size="large" />
                    INFO
                </Button>
        }
        />
    )
}

export default compose(
    hot(module),
    withAxios,
)(PopUpInfo);
